export const getFailedScriptError = e => new Error('Failed to load installApp API' + (e ? `: ${e.message}` : ''));
export const INSTALLER_TOPOLOGY_API_URL = '/_serverless/app-installer-fed-serverless/getInstallerTopology';
export const APP_STATIC_BUNDLE_FILE = 'app.bundle.min.js';
export const APP_CSS_FILE = 'app.min.css';
export * from '../utils/i18nResources';
//# sourceMappingURL=utils.js.map